import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';

export default function ARScannerCTA() {
  const navigate = useNavigate();

  return (
    <div className="relative overflow-hidden bg-gradient-to-br from-[#0A1628] via-[#0F172A] to-[#0A1628] border border-[rgba(6,182,212,0.25)] rounded-xl p-5 md:p-6">
      {/* Background glow */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-48 h-48 bg-[rgba(6,182,212,0.06)] rounded-full blur-3xl" />
      </div>

      <div className="relative flex flex-col sm:flex-row items-center gap-4">
        {/* Icon */}
        <div className="w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-gradient-to-br from-[#06B6D4] to-[#0891B2] flex items-center justify-center shadow-lg flex-shrink-0">
          <Icon name="ScanLine" size={32} color="#0F172A" strokeWidth={2.5} />
        </div>

        {/* Content */}
        <div className="flex-1 text-center sm:text-left">
          <h3 className="font-heading font-bold text-lg md:text-xl text-[#F8FAFC] mb-1">
            AR Product Scanner
          </h3>
          <p className="text-sm text-[#94A3B8] leading-relaxed mb-3">
            Scan any product to instantly see its budget impact, price comparisons, and smarter alternatives.
          </p>
          <div className="flex flex-wrap gap-2 justify-center sm:justify-start">
            <div className="flex items-center gap-1.5 bg-[rgba(6,182,212,0.1)] px-3 py-1 rounded-full">
              <Icon name="Zap" size={12} color="#06B6D4" />
              <span className="text-xs text-[#06B6D4]">Real-time analysis</span>
            </div>
            <div className="flex items-center gap-1.5 bg-[rgba(16,185,129,0.1)] px-3 py-1 rounded-full">
              <Icon name="DollarSign" size={12} color="#10B981" />
              <span className="text-xs text-[#10B981]">Budget impact</span>
            </div>
            <div className="flex items-center gap-1.5 bg-[rgba(124,58,237,0.1)] px-3 py-1 rounded-full">
              <Icon name="ArrowLeftRight" size={12} color="#7C3AED" />
              <span className="text-xs text-[#A78BFA]">Alternatives</span>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="flex-shrink-0">
          <Button
            variant="default"
            size="lg"
            iconName="ScanLine"
            iconPosition="left"
            onClick={() => navigate('/ar-scanner-interface')}
            className="min-w-[140px]"
          >
            Start Scanning
          </Button>
        </div>
      </div>
    </div>
  );
}